export interface PublicationLagData {
  transaction_type: string
  avg_lag_days: number
  transaction_count: number
}

export interface DailyActivityData {
  date: string
  transaction_count: number
}

export interface MonthlyActivityData {
  month: string
  transaction_count: number
  by_type?: {
    type: string
    count: number
  }[]
}

export interface MarketTimingChartLabels {
  publicationLag?: string
  publicationLagSubtext?: string
  avgLagDays?: string
  transactions?: string
  activityCalendar?: string
  activityCalendarSubtext?: string
  noActivity?: string
  monthlyActivity?: string
  monthlyActivitySubtext?: string
  totalTransactions?: string
  numberOfTransactions?: string
  noData?: string
}

export const DEFAULT_MARKET_TIMING_CHART_LABELS: MarketTimingChartLabels = {
  publicationLag: 'Publication Lag Analysis',
  publicationLagSubtext: 'Average days between transaction and publication',
  avgLagDays: 'Average Lag (days)',
  transactions: 'Transactions',
  activityCalendar: 'Market Activity Calendar',
  activityCalendarSubtext: 'Transaction volume by day',
  noActivity: 'No activity',
  monthlyActivity: 'Monthly Transaction Activity',
  monthlyActivitySubtext: 'Transaction volume over time',
  totalTransactions: 'Total Transactions',
  numberOfTransactions: 'Number of Transactions',
  noData: 'No market timing data available',
}

export interface MarketTimingChartProps {
  publicationLagData?: PublicationLagData[]
  dailyActivityData?: DailyActivityData[]
  monthlyActivityData?: MonthlyActivityData[]
  loading?: boolean
  error?: string | null
  height?: number
  labels?: Partial<MarketTimingChartLabels>
}
